import reportTabs from '@home/pages/studio/MultiReports/component/reportTabs';
import techland from './techland';
import potentialMarket from './potentialMarket';
import opinons from './opinons';
import common from './common';
import socialIndex from './socialIndex';
import kol from './kol';
import studioAssessment from './studioAssessment';
import competitor from './competitor';
import inGameAnalytics from './inGameAnalytics';
import casualHub from './casualHub';
import databrainLink from './databrainLink';
import AuthPath from '@home/pages/studio/authPath/AuthPathContent';
import TabContainer from '@home/pages/studio/tabContainer/TabContainerContent';

export default {
  reportTabs,
  AuthPath,
  TabContainer,
  authPathTabs: TabContainer,
  ...techland,
  ...potentialMarket,
  ...opinons,
  ...common,
  ...socialIndex,
  ...kol,
  ...studioAssessment,
  ...competitor,
  ...inGameAnalytics,
  ...casualHub,
  ...databrainLink,
};
